export default __webpack_public_path__ + "static/media/User- friendly.76990a43.png";